import {publicFiles} from '@/api/api-endpoints'

const title = 'Текстовые материалы территориальной схемы';
const append = (menu, { data }) => {
  menu.push({
    title,
    ...(process.env.REGION === 'len') && { href: 'https://www.gov.spb.ru/gov/otrasl/ecology/obrashenie-s-othodami/obshestvennye-obsuzhdeniya-proekta-territorialnoj-shemy-obrasheniya-s-/' },
    number: menu.length + 1,
    childs: data?.length ? data.map((item) =>({...item, href:publicFiles.file(item.id)})) : null
  });
  //часть меню лежит в model.js ¯\_(ツ)_/¯
  //как это здорово!
  if (process.env.REGION === 'kursk') {
    menu.push({
      title: 'Описание форматов взаимодействия электронных сервисов',
      href: 'http://kursk-tko.etton.ru/storage/api.docx',
      number: menu.length + 1
    })
  }
  return menu;
};
export {
  append
}
